import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class Behavior {
  // 获取摄像头列表
  static async getCameraList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/area/handover/area/getcameralist?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 更新列表
  static async updateCameraList(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/share/common/update_table', payload))
    return Callback(err, res)
  }
  // 获取底部列表
  static async getBottomList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Rpt_Camera/rpt_camera_page_list?ext_attribute4=${payload.ext_attribute4}`
      )
    )
    return Callback(err, res)
  }
  // 摄像头配置——>上传接口
  static async uploadFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/upload', payload, {
        'Content-Type': 'multipart/form-data',
      })
    )
    return Callback(err, res)
  }
  // 摄像头配置——>更新字段
  static async updateTable(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/share/common/update_table', payload))
    return Callback(err, res)
  }
}
